'use client';

import useUser from 'grandus-lib/hooks/useUser';
import Link from 'next/link';
import LoginIcon from 'components/_other/icons/LoginIcon';

const HeaderUser = ({}) => {
  const { user } = useUser();

  if (user) {
    return (
      <Link href={'/profil'} className={'flex text-nowrap gap-x-2 text-black dark:text-beige'}>
        <LoginIcon className="d-inline d-lg-none" />
        <span className="hidden lg:inline">
          {user?.attributes?.name ?? user.email}
        </span>
      </Link>
    );
  }

  return (
    <Link href="/prihlasenie">
      <LoginIcon className={'text-black dark:text-beige'} />
    </Link>
  );
};

export default HeaderUser;
